var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountActivityUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_6600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1189 17.2856H20.0285C19.5438 17.2856 19.1487 17.6807 19.1487 18.1653C19.1487 18.4121 19.2536 18.6345 19.4172 18.7949L27.2265 26.6042C27.309 26.6929 27.4088 26.7636 27.5199 26.812C27.6309 26.8603 27.7507 26.8852 27.8718 26.8852C28.0163 26.8855 28.1587 26.8502 28.2862 26.7824C28.4138 26.7145 28.5227 26.6162 28.6032 26.4963C30.5232 24.2676 31.7579 21.4371 31.9802 18.3227C31.9925 18.2711 31.9987 18.2182 31.9987 18.1652C31.9987 18.0497 31.976 17.9353 31.9318 17.8285C31.8876 17.7218 31.8228 17.6248 31.7411 17.5431C31.6594 17.4614 31.5624 17.3966 31.4556 17.3524C31.3489 17.3083 31.2345 17.2856 31.1189 17.2856ZM16.6794 1.34271C16.1947 1.34568 15.8027 1.73781 15.8027 2.2224V14.5476C15.8027 15.0353 16.1947 15.4304 16.6794 15.4304H29.0077C29.4924 15.4304 29.8874 15.0353 29.8874 14.5476C29.4521 7.45449 23.7756 1.77801 16.6794 1.34271Z",
    fill: "#3375BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4549 25.8851L14.3615 16.7917C14.2073 16.6343 14.1147 16.4151 14.1147 16.1775L14.1114 3.33359C14.1115 3.21845 14.0889 3.10443 14.0449 2.99803C14.0008 2.89164 13.9363 2.79497 13.8549 2.71355C13.7734 2.63214 13.6768 2.56757 13.5704 2.52354C13.464 2.47951 13.35 2.45689 13.2348 2.45697C5.84836 2.90768 -0.000976562 9.04395 -0.000976562 16.5417C-0.000976562 24.3356 6.31763 30.6572 14.1114 30.6572C17.6673 30.6572 20.9145 29.3423 23.3963 27.1722C23.4941 27.0903 23.5728 26.9878 23.6267 26.872C23.6806 26.7563 23.7084 26.6301 23.7081 26.5025C23.7079 26.2714 23.617 26.0497 23.4549 25.8851Z",
    fill: "#3375BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_6600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActivityUnread);
export default __webpack_public_path__ + "static/media/accountActivity_unread.46b91e56f46f6c3edc861de3e4e39cc6.svg";
export { ForwardRef as ReactComponent };